import { useHistory } from "react-router-dom";
import { BorderButton } from "src/components/buttons/BorderButton";
import { WithFormProps } from "src/components/forms/Form";
import InputRadio from "src/components/inputs/InputRadio";
import Container from "src/components/layout/Container";
import { StartHeader } from "src/components/start/StartHeader";
import { StartFormValues } from "types/start";

interface Props extends WithFormProps<StartFormValues> {
  onNext: () => void;
}

export default function StartStarted(props: Props) {
  const history = useHistory();

  async function onNext() {
    if (
      props.form.getFieldValue("start") === "create" ||
      !props.form.getFieldValue("start")
    ) {
      history.push("/start/programming");
    } else {
      history.push("/start/schedule");
    }
  }

  props.form.getFieldDecorator("start", {
    initialValue: "create",
  });

  return (
    <>
      <StartHeader />

      <div className="pt-24">
        <Container large>
          <h1 className="text-3xl font-bold text-organization">
            How would you like to get started?
          </h1>

          <div className="mb-8 flex gap-4 sm:block">
            <div className="flex-1 sm:mb-4">
              <InputRadio
                value="create"
                checked={props.form.getFieldValue("start") === "create"}
                onChange={(value) =>
                  props.form.setFieldsValue({ start: value })
                }
                className="rounded-xl border border-borderGray p-4"
                label={
                  <strong>Create my organization in Captyn right now.</strong>
                }
              />
            </div>
            <div className="flex-1">
              <InputRadio
                value="see"
                checked={props.form.getFieldValue("start") === "see"}
                onChange={(value) =>
                  props.form.setFieldsValue({ start: value })
                }
                className="rounded-xl border border-borderGray p-4"
                label={<strong>I want to see Captyn in action first.</strong>}
              />
            </div>
          </div>

          <BorderButton type="submit" onClick={onNext}>
            Continue
          </BorderButton>
        </Container>
      </div>
    </>
  );
}
